import 'styles/pages/join-us';

import React from 'react';
import { render } from 'react-dom';
import 'react-select/dist/react-select.css';

import JobBoard from 'join-us/components/JobBoard';
import ValuesGallery from 'join-us/components/ValuesGallery';

if (document.querySelector('.js-join-us-page')) {
  const valuesGalleryEl = document.getElementById('js-values-gallery');
  const values = JSON.parse(valuesGalleryEl.dataset.values);
  render(<ValuesGallery values={values} />, valuesGalleryEl);

  global.__greenhouseOfficesCallback = data => {
    render(
      <JobBoard offices={data.offices} />,
      document.getElementById('js-job-board')
    );
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/join-us.js